import { Divider, Menu, MenuItem, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { BorderSide } from "~/features/andon/andon.types";

import CellBorderControls from "./CellBorderControls";

type AndonTextLabelEditMenuProps = {
  open: boolean;
  anchorPosition: { left: number; top: number } | undefined;
  layoutItemId: string;
  enableAndonBorders: boolean;
  cellBorderSides: BorderSide[];
  cellBorderColor: string;
  onClose: (
    event?: object | React.SyntheticEvent | Event | null,
    reason?: string
  ) => void;
  onEdit: (layoutItemId: string) => void;
  onDelete: (layoutItemId: string) => void;
  onSetCellBorder: (sides: BorderSide[], color: string) => void;
};

export default function AndonTextLabelEditMenu({
  open,
  anchorPosition,
  layoutItemId,
  enableAndonBorders,
  cellBorderSides,
  cellBorderColor,
  onClose,
  onEdit,
  onDelete,
  onSetCellBorder
}: AndonTextLabelEditMenuProps) {
  const { t } = useTranslation();

  return (
    <Menu
      id="andon-text-label-edit-menu"
      anchorReference="anchorPosition"
      anchorPosition={anchorPosition}
      open={open}
      onClose={onClose}
      MenuListProps={{
        "aria-label": t("edit text label")
      }}
    >
      <MenuItem onClick={() => onEdit(layoutItemId)}>
        <Typography>{t("edit")}</Typography>
      </MenuItem>
      <MenuItem onClick={() => onDelete(layoutItemId)}>
        <Typography>{t("delete")}</Typography>
      </MenuItem>
      {enableAndonBorders && (
        <>
          <Divider />
          <CellBorderControls
            cellBorderSides={cellBorderSides}
            cellBorderColor={cellBorderColor}
            onSetCellBorder={onSetCellBorder}
          />
        </>
      )}
    </Menu>
  );
}
